<script>
import {createEditor, reteRender} from "@src/functions/reteEditor";

/**
 * Компонент отображает mindMap и эмитит чистые события в корневой компонент
 */

export default {
  props: ['data', 'select', 'freeze', 'track', 'fl_ai'],
  data() {
    return {
      editor: null,
      busy: false,
    }
  },
  watch: {
    freeze() {
      this.editorFreeze(this.freeze)
    }
  },
  async mounted () {    
    // await this.mindMapRender()
    this.editor = await createEditor(
      '#rete', {
        onConnectCreate: this.onCreateConnect,
        onConnectRemove: this.onRemoveConnect,
        onConnectSelected: this.onConnectSelected,
        onNodeDragged: this.onNodeDragged,
        onNodeEdit: this.onNodeEdit,
        onNodeRemove: this.onNodeRemove,
        onNodeCreate: this.nodeCreate,
        onNodeSelected: this.onNodeSelected,
        onPathChangeType: this.onPathChangeType,
        onPathEdit: this.onPathEdit
      },
      this.fl_ai
    )
  },
  methods: {
    async mindMapInit(fl_ai = False) {
      console.log('fl_ai', fl_ai)    
      
    },
    async mindMapRender(forceData = []) {
      // console.log('mindMapRender');
      this.busy = true
      await reteRender(this.editor, this.data.length ? this.data : forceData, this.track)
      this.busy = false
    },
    getConnection(inId, outId) {
      const childNode = this.editor.nodes.find(node => node.id === outId)
      const connection = childNode.inputs.get('input').connections.find(connection => connection.output.node.id === inId)
      return connection
    },
    editorFreeze(state) {
      this.editor.freeze = state
    },
    nodeCreate(type, position){
      this.$emit('nodeCreate', type, position)
    },
    onNodeEdit({node}) {
      this.editor.trigger('nodefocus', {node})
      this.$emit('nodeEdit', node.data.index, node.id)
    },
    onNodeRemove({node}) {
      this.$emit('nodeDelete', node.id)
    },
    onNodeSelected(node) { },
    onConnectSelected(connections) { },
    onCreateConnect(connection) {
      // Срабатывает при создании связи между нодами
      if (this.busy) return
      const child = connection.input.node.id
      const id = connection.output.node.id
      setTimeout(() => this.$emit('createPath', {id, child}),200)

    },
    onRemoveConnect(connection) {
      // Срабатывает при удалении связи между нодами
      if (this.busy) return
      const child = connection.input.node.id
      const id = connection.output.node.id
      setTimeout(() => this.$emit('removePath', {id, child}), 200)

    },
    onNodeDragged (node) {
      // Срабатывает при завершении перемещения ноды
      if (this.busy) return
      const blockIndex = this.data.findIndex((block) => block.id === node.id)
      if (blockIndex !== -1 && (this.data[blockIndex].position[0] !== node.position[0] || this.data[blockIndex].position[1] !== node.position[1]))
        this.$emit('nodeDragged',{blockId: node.id, position: node.position})
    },
    onPathChangeType (path, to) {
      // Смена типа логического пути
      const parentId = path.connection.output.node.id
      const childId = path.connection.input.node.id

      this.$emit('changePathType', {instanceId: parentId, childId, type: to})
    },
    onPathEdit ({node: path}) {
      const parentId = path.connection.output.node.id
      this.$emit('editPath', {instanceId: parentId, path})
    }
  }
}
</script>

<template>
  <div class="rete-wrap">
    <div id="rete" />
  </div>
</template>

<style scoped>
  #rete {
    /*margin-top: 60px;*/
    height: 100%
  }

  .rete-wrap {
    width: 100%;
    height: calc(100vh - 72px);;
  }

  </style>

<style>
  #rete .connection .main-path {
    stroke-width: 2px;
    stroke: #9d9d9d;
  }

  #rete .connection .main-path.focus {
    stroke: #ff8e00;
  }

  #rete .connection .main-path.focus ~ .marker {
    stroke: #ff8e00;
    fill: #ff8e00;
  }

  #rete .connection .main-path-action-area {
    stroke-width: 28px;
    fill: none;
    cursor: pointer;
  }

  #rete .node {
    border: 1px solid transparent;
  }

  #rete .node.focus {
    /*background: #ff8e00;*/
    border: 1px solid #ff8e00;
  }

  #rete .context-menu {
    width: max-content;
    box-shadow: #7c7c7c33 0 0 10px 0;
    background-color: rgba(255, 255, 255, 0.70);
    padding: 0px;
    border-radius: 8px;
  }

  #rete .context-menu .item {
    color: #0a0c0d;
    border-bottom: 1px solid #ebebeb;
    background-color: unset;
    padding: 10px 30px 10px 20px;
  }

  #rete .context-menu .item:hover {
    background-color: rgba(247, 247, 247, 0.70);
  }

  #rete .context-menu .subitems {
    width: max-content;
    box-shadow: #7c7c7c33 0 0 10px 0;
    background-color: rgba(255, 255, 255, 0.85);
    border-radius: 8px;    
  }

  #rete .context-menu .hasSubitems:after {
    right: -10px;
    z-index: -1;
  }

  #rete .context-menu .subitems .item {
    padding: 10px 30px 10px 20px;
  }

  #rete .rete-background.default {
    background-image: linear-gradient(90deg, #edeff5 29px, transparent 10%), linear-gradient(#edeff5 29px, #d9d9d9 24px)
  }
</style>